module.exports = __webpack_public_path__ + "img/img4-4.deb9a8d8.png";